import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  FaPlus,
  FaUser,
  FaCog,
  FaSignOutAlt,
  FaCalendarAlt,
  FaUsers,
  FaClock,
  FaPuzzlePiece,
  FaCrown,
  FaChartBar,
  FaCogs,
  FaQuestionCircle,
  FaChevronRight,
  FaBars,
  FaTimes,
  FaBell,
  FaSearch,
  FaHome,
  FaEnvelope,
  FaFileAlt,
  FaShieldAlt,
  FaCreditCard,
  FaMobileAlt,
  FaUserCheck
} from 'react-icons/fa';
import './NavBar.css';
import logo from '../../img/small.png';

const NavBar = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [user, setUser] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const searchResults = {
    events: [
      { id: 1, title: 'Team Meeting', date: 'Today, 2:00 PM', type: 'event' },
      { id: 2, title: 'Project Deadline', date: 'Tomorrow, 5:00 PM', type: 'event' },
      { id: 3, title: 'Client Call', date: 'Dec 15, 10:00 AM', type: 'event' }
    ],
    meetings: [
      { id: 1, title: 'Weekly Sync', time: '30 mins', participants: 5, type: 'meeting' },
      { id: 2, title: 'Design Review', time: '1 hour', participants: 3, type: 'meeting' }
    ],
    contacts: [
      { id: 1, name: 'John Doe', email: 'john@company.com', role: 'Manager', type: 'contact' },
      { id: 2, name: 'Sarah Wilson', email: 'sarah@company.com', role: 'Designer', type: 'contact' }
    ]
  };

  const searchCategories = [
    { id: 'all', label: 'All' },
    { id: 'events', label: 'Events' },
    { id: 'meetings', label: 'Meetings' },
    { id: 'contacts', label: 'Contacts' }
  ];
  const handleSearch = (e) => {
    if (e.key === 'Enter' && searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}&category=${activeCategory}`);
      setSearchQuery('');
    }
  };
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [notificationDropdownOpen, setNotificationDropdownOpen] = useState(false);

  const userDropdownRef = useRef(null);
  const notificationDropdownRef = useRef(null);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        userDropdownRef.current &&
        !userDropdownRef.current.contains(e.target)
      ) {
        setUserDropdownOpen(false);
      }
      if (
        notificationDropdownRef.current &&
        !notificationDropdownRef.current.contains(e.target)
      ) {
        setNotificationDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  // Mock user data functions


  const toggleUserDropdown = () => {
    setUserDropdownOpen(!userDropdownOpen);
  };



  const handleCategorySelect = (categoryId) => {
    setActiveCategory(categoryId);
  };

  const getFilteredResults = () => {
    if (!searchQuery.trim()) return [];

    const query = searchQuery.toLowerCase();
    let results = [];

    if (activeCategory === 'all' || activeCategory === 'events') {
      results = [...results, ...searchResults.events.filter(item =>
        item.title.toLowerCase().includes(query)
      )];
    }

    if (activeCategory === 'all' || activeCategory === 'meetings') {
      results = [...results, ...searchResults.meetings.filter(item =>
        item.title.toLowerCase().includes(query)
      )];
    }

    if (activeCategory === 'all' || activeCategory === 'contacts') {
      results = [...results, ...searchResults.contacts.filter(item =>
        item.name.toLowerCase().includes(query) || item.email.toLowerCase().includes(query)
      )];
    }

    return results.slice(0, 6); // Limit to 6 results
  };
  const getCategoryIcon = (type) => {
    switch (type) {
      case 'event': return FaCalendarAlt;
      case 'meeting': return FaUsers;
      case 'contact': return FaUser;
      default: return FaSearch;
    }
  };
  useEffect(() => {
    // Get user data from localStorage
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }

    // Close sidebar when route changes
    setSidebarOpen(false);
  }, [location]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };



  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('AUTH_TOKEN_KEY');
    setUser(null);
    setUserDropdownOpen(false);
    navigate('/login');
  };

  // Get user's first letter for avatar
  const getUserInitial = () => {
    if (user && user.name) {
      return user.name.charAt(0).toUpperCase();
    }
    return 'U';
  };

  // Get user's display name
  const getUserName = () => {
    if (user && user.name) {
      return user.name;
    }
    return 'User';
  };

  const mainMenuItems = [
    { text: 'Dashboard', icon: FaHome, path: '/', badge: null },
    { text: 'Events', icon: FaCalendarAlt, path: '/events', badge: null },
    { text: 'Meetings', icon: FaUsers, path: '/meetings', badge: null },
    { text: 'Availability', icon: FaClock, path: '/availability', badge: null },
    { text: 'Profile', icon: FaUserCheck, path: '/profile', badge: null },
    // { text: 'Messages', icon: FaEnvelope, path: '/messages', badge: null },
    // { text: 'Documents', icon: FaFileAlt, path: '/documents', badge: null },
  ];

  const toolsMenuItems = [
    { text: 'Integrations', icon: FaPuzzlePiece, path: '/integration', badge: null },
    // { text: 'Analytics', icon: FaChartBar, path: '/analytics', badge: null },
    // { text: 'Settings', icon: FaCog, path: '/settings', badge: null },
  ];

  const supportMenuItems = [
    // { text: 'Upgrade Plan', icon: FaCrown, path: '/upgrade', badge: 'Pro' },
    // { text: 'Admin Center', icon: FaCogs, path: '/admin', badge: null },
    // { text: 'Security', icon: FaShieldAlt, path: '/security', badge: null },
    // { text: 'Billing', icon: FaCreditCard, path: '/billing', badge: null },
    { text: 'Help Center', icon: FaQuestionCircle, path: '/helpcenter', badge: null },
    // { text: 'Mobile App', icon: FaMobileAlt, path: '/mobile', badge: null },
  ];

  const isActivePath = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <>
      {/* Top Navigation Bar - REARRANGED */}
      <nav className="navbar navbar-expand-lg navbar-main fixed-top">
        <div className="container-fluid p-0">
          <div className="navbar-container">

            {/* Left Section - Brand & Menu */}
            <div className="navbar-left">
              {/* Sidebar Toggle */}
              <button
                className="action-btn"
                type="button"
                onClick={toggleSidebar}
              >
                <FaBars size={16} />
              </button>

              {/* Brand */}
              <div className="brand-section">
                <Link className="navbar-brand-custom" to="/dashboard" onClick={closeSidebar}>
                  <div className="brand-logo">
                    <img src={logo} alt="Meetify logo" className="brand-logo-image" />
                  </div>
                  <span>Meetify</span>


                </Link>
              </div>
            </div>

            {/* Center Section - Enhanced Search */}


            {/* Right Section - Actions */}
            <div className="navbar-right">
              {/* Quick Actions */}
              <div className="d-flex align-items-center gap-3">
                {/* Search Button - Mobile */}
                <button className="btn btn-outline-secondary btn-sm d-lg-none d-flex align-items-center justify-content-center"
                  style={{ width: '36px', height: '36px' }}>
                  <FaSearch size={14} />
                </button>

                {/* Notifications */}
                <div className="dropdown" ref={notificationDropdownRef}>
                  <button className="btn btn-outline-secondary btn-sm position-relative d-flex align-items-center justify-content-center"
                    style={{ width: '36px', height: '36px' }}
                    onClick={() => setNotificationDropdownOpen(!notificationDropdownOpen)}>
                    <FaBell size={14} />
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                      style={{ fontSize: '0.6rem', padding: '2px 4px' }}>
                      3
                    </span>
                  </button>

                  {/* Notification Dropdown */}
                  {notificationDropdownOpen && (
                    <div className="dropdown-menu dropdown-menu-end show shadow border-0"
                      style={{ minWidth: '300px', marginTop: '8px' }}>
                      <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                        <h6 className="mb-0 fw-bold">Notifications</h6>
                        <button className="btn btn-sm btn-outline-secondary">Mark all read</button>
                      </div>
                      <div className="dropdown-item-text p-3">
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: '32px', height: '32px' }}>
                              <FaCalendarAlt size={14} className="text-white" />
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <p className="mb-1 small">New meeting scheduled for tomorrow</p>
                            <small className="text-muted">2 minutes ago</small>
                          </div>
                        </div>
                      </div>
                      <div className="dropdown-divider"></div>
                      <a href="#" className="dropdown-item text-center text-primary small">
                        View all notifications
                      </a>
                    </div>
                  )}
                </div>



                <div className="dropdown position-relative" ref={userDropdownRef}>
                  <button
                    className="btn btn-link text-decoration-none p-0 dropdown-toggle d-flex align-items-center gap-2"
                    type="button"
                    onClick={toggleUserDropdown}
                    style={{ border: 'none', minWidth: 'auto' }}
                  >
                    <div className="user-avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold flex-shrink-0"
                      style={{
                        width: '36px',
                        height: '36px',
                        fontSize: '14px',
                        minWidth: '36px'
                      }}>
                      {getUserInitial()}
                    </div>
                    <div className="user-info d-none d-xl-block text-start flex-shrink-0"
                      style={{ minWidth: '0', overflow: 'hidden' }}>
                      <div className="user-name small fw-semibold text-dark text-truncate"
                        style={{ lineHeight: '1.2', maxWidth: '120px' }}>
                        {getUserName()}
                      </div>
                      <div className="user-role small text-muted text-truncate"
                        style={{ lineHeight: '1.2', maxWidth: '120px' }}>
                        Premium Member
                      </div>
                    </div>
                  </button>

                  {userDropdownOpen && (
                    <div className="dropdown-menu dropdown-menu-end show shadow border-0 position-absolute"
                      style={{
                        top: '100%',
                        right: '0',
                        marginTop: '8px',
                        minWidth: '280px',
                        maxWidth: 'min(400px, 90vw)',
                        zIndex: 9999
                      }}>
                      {/* User Header */}
                      <div className="px-3 py-3 border-bottom">
                        <div className="d-flex align-items-center">
                          <div className="user-avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold me-3 flex-shrink-0"
                            style={{
                              width: '48px',
                              height: '48px',
                              fontSize: '18px',
                              minWidth: '48px'
                            }}>
                            {getUserInitial()}
                          </div>
                          <div className="flex-grow-1" style={{ minWidth: '0' }}>
                            <div className="fw-semibold text-dark text-truncate" style={{ fontSize: '1rem' }}>
                              {getUserName()}
                            </div>
                            <small className="text-muted text-truncate d-block">Premium Member</small>
                          </div>
                        </div>
                      </div>

                      {/* Dropdown Items */}
                      <div className="py-2">
                        <Link to="/profile" className="dropdown-item d-flex align-items-center py-3 px-3 text-decoration-none"
                          onClick={() => setUserDropdownOpen(false)}
                          style={{ minWidth: '0' }}>
                          <FaUser className="me-3 text-muted flex-shrink-0" size={16} />
                          <span className="text-truncate" style={{ fontSize: '0.9rem' }}>Profile</span>
                        </Link>
                        {/* <Link to="/settings" className="dropdown-item d-flex align-items-center py-3 px-3 text-decoration-none"
                          onClick={() => setUserDropdownOpen(false)}
                          style={{ minWidth: '0' }}>
                          <FaCog className="me-3 text-muted flex-shrink-0" size={16} />
                          <span className="text-truncate" style={{ fontSize: '0.9rem' }}>Settings</span>
                        </Link> */}
                        <Link to="/helpcenter" className="dropdown-item d-flex align-items-center py-3 px-3 text-decoration-none"
                          onClick={() => setUserDropdownOpen(false)}
                          style={{ minWidth: '0' }}>
                          <FaQuestionCircle className="me-3 text-muted flex-shrink-0" size={16} />
                          <span className="text-truncate" style={{ fontSize: '0.9rem' }}>Help Center</span>
                        </Link>

                        <div className="dropdown-divider my-2"></div>

                        <button className="dropdown-item d-flex align-items-center py-3 px-3 text-danger border-0 bg-transparent w-100"
                          onClick={handleLogout}
                          style={{ minWidth: '0' }}>
                          <FaSignOutAlt className="me-3 flex-shrink-0" size={16} />
                          <span className="text-truncate" style={{ fontSize: '0.9rem' }}>Logout</span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <style>{`
        .navbar-right .btn {
          border-radius: 8px;
          transition: all 0.2s ease;
        }
        
        .navbar-right .btn-outline-secondary {
          border-color: #dee2e6;
          color: #6c757d;
        }
        
        .navbar-right .btn-outline-secondary:hover {
          background-color: #f8f9fa;
          border-color: #adb5bd;
        }
        
        .navbar-right .btn-primary {
          background: linear-gradient(135deg, #007bff, #0056b3);
          border: none;
          padding: 8px 16px;
          font-weight: 500;
        }
        
        .navbar-right .btn-primary:hover {
          background: linear-gradient(135deg, #0056b3, #004085);
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
        }
        
        .user-avatar {
          transition: transform 0.2s ease;
        }
        
        .user-avatar:hover {
          transform: scale(1.05);
        }
        
        .dropdown-menu {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e3e6f0 !important;
  border-radius: 12px !important;
  overflow: hidden;
}

.dropdown-item {
  transition: all 0.2s ease;
  margin: 0 !important;
  border-radius: 0 !important;
}

.dropdown-item:hover {
  background-color: #f8f9fa !important;
  transform: none;
}

.dropdown-divider {
  margin: 0.5rem 0 !important;
}

/* Ensure dropdown stays on top */
.navbar-right .dropdown {
  z-index: 9999;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .dropdown-menu {
    position: fixed !important;
    top: 60px !important;
    right: 10px !important;
    left: auto !important;
    transform: none !important;
    max-width: calc(100vw - 20px) !important;
  }
  
  .user-info {
    display: none !important;
  }
}

/* Prevent body scroll when dropdown is open */
body.dropdown-open {
  overflow: hidden;
}
        
        .badge {
          font-size: 0.6rem;
        }
        
        @media (max-width: 768px) {
          .navbar-right .d-flex.gap-3 {
            gap: 1rem !important;
          }
          
          .btn-primary span {
            display: none;
          }
          
          .btn-primary {
            padding: 8px;
            width: 36px;
            height: 36px;
          }
        }
        
        @media (max-width: 576px) {
          .navbar-right .d-flex.gap-3 {
            gap: 0.5rem !important;
          }
        }
      `}</style>
            </div>

          </div>
        </div>
      </nav>

      {/* Sidebar Overlay - Mobile only */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay d-lg-none"
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Sidebar Header */}
        <div className="sidebar-header p-3 border-bottom bg-white d-flex align-items-center justify-content-between">
          <Link to="/dashboard" onClick={closeSidebar} className="d-flex align-items-center text-decoration-none">
            <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3"
              style={{ width: '40px', height: '40px', overflow: 'hidden' }}>
              <img src={logo} alt="Meetify logo" className="brand-logo-image" />
            </div>
            <div>
              <div className="fw-bold text-primary">Meetify</div>
              <div className="text-muted small text-dark">Scheduling Platform</div>
            </div>
          </Link>

        </div>

        {/* User Info */}




        {/* Main Navigation */}
        <div className="sidebar-content">
          {/* Main Menu */}
          <div className="nav-section-title">Main Menu</div>
          <div className="nav-items">
            {mainMenuItems.map((item, index) => {
              const IconComponent = item.icon;
              const isActive = isActivePath(item.path);

              return (
                <div className="nav-item-custom" key={item.text}>
                  <Link
                    className={`nav-link-custom ${isActive ? 'active' : ''}`}
                    to={item.path}
                    onClick={closeSidebar}
                  >
                    <IconComponent className="nav-icon" size={16} />
                    <span className="nav-text">{item.text}</span>
                    {item.badge && (
                      <span className="nav-badge">{item.badge}</span>
                    )}
                    {isActive && (
                      <FaChevronRight size={12} />
                    )}
                  </Link>
                </div>
              );
            })}
          </div>

          {/* Tools Menu */}
          <div className="nav-section-title">Tools & Features</div>
          <div className="nav-items">
            {toolsMenuItems.map((item) => {
              const IconComponent = item.icon;

              return (
                <div className="nav-item-custom" key={item.text}>
                  <Link
                    className={`nav-link-custom ${isActivePath(item.path) ? 'active' : ''}`}
                    to={item.path}
                    onClick={closeSidebar}
                  >
                    <IconComponent className="nav-icon" size={16} />
                    <span className="nav-text">{item.text}</span>
                    {item.badge && (
                      <span className="nav-badge">{item.badge}</span>
                    )}
                  </Link>
                </div>
              );
            })}
          </div>

          {/* Support Menu */}
          <div className="nav-section-title">Support & Account</div>
          <div className="nav-items">
            {supportMenuItems.map((item) => {
              const IconComponent = item.icon;

              return (
                <div className="nav-item-custom" key={item.text}>
                  <Link
                    className={`nav-link-custom ${isActivePath(item.path) ? 'active' : ''}`}
                    to={item.path}
                    onClick={closeSidebar}
                  >
                    <IconComponent className="nav-icon" size={16} />
                    <span className="nav-text">{item.text}</span>
                    {item.badge && (
                      <span className="nav-badge">{item.badge}</span>
                    )}
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="main-content">
        {children}
      </main>
    </>
  );
};

export default NavBar;
